export default {
  "contact.title": "Contact us",
  "contact.subtitle": "We are here to help you plan your perfect trip to Baja California Sur",
  "contact.infoTitle": "Contact information",
  "contact.emailLabel": "Email",
  "contact.phoneLabel": "Phone",
  "contact.addressLabel": "Address",
  "contact.addressValue": "La Paz, B.C.S., México",
  "contact.whatsappLabel": "WhatsApp",
  "contact.hoursTitle": "Business hours",
  "contact.weekdays": "Monday - Friday",
  "contact.saturday": "Saturday",
  "contact.sunday": "Sunday",
  "contact.closed": "Closed",
  "contact.emergencyTitle": "Need urgent help?",
  "contact.emergencyDesc": "If you have an issue with a booking happening right now, reach us directly on WhatsApp.",
  "contact.emergencyButton": "Chat on WhatsApp",
  "contact.nameLabel": "Name",
  "contact.namePlaceholder": "Your full name",
  "contact.subjectLabel": "Subject",
  "contact.subjectPlaceholder": "How can we help?",
  "contact.messageLabel": "Message",
  "contact.messagePlaceholder": "Tell us more about your question or issue...",
  "contact.maxChars": "Maximum 500 characters",
  "contact.sendButton": "Send message",
  "contact.privacyNote": "By sending this message you agree to our",
  "contact.privacyLink": "privacy policy",
  "contact.sentTitle": "Message sent",
  "contact.sentDesc": "We received your message and will respond within 24 hours.",
  "contact.sendAnother": "Send another message",
};